/* ==========================================================================
   Kopstorm CRO Suite - Wave 2 - kopstorm-w2.js
   Anavrin / byanavrin.com

   Behaviour for the second wave. Loaded deferred, only when the suite and
   wave 2 are enabled in theme settings. No dependencies.

   Everything reacts to the flag classes set by kopstorm-cro-flags.liquid, so
   Intelligems only ever needs a single expression of variant JavaScript:

       KopstormCRO.enable('w04')

   Each module reads its own flag at run time and re-reads it on the
   kopstorm:flag event, so a flag flipped after page load still applies.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.documentElement;

  /* ------------------------------------------------------------------------
     Test registry. Single source of truth for the preview toolbar and for
     anyone reading this file to find out what shipped.
     ------------------------------------------------------------------------ */
  var TESTS = [
    { id: 'w01', wave: 'Wave 1', label: 'Compact PDP above the fold', exclusive: 'pdp-layout' },
    { id: 'w02', wave: 'Wave 1', label: 'Gallery lightbox upgrade' },
    { id: 'w03', wave: 'Wave 1', label: 'Klarna messaging at the buy button' },
    { id: 'w04', wave: 'Wave 1', label: 'Bundle offer on PDP' },
    { id: 'w05', wave: 'Wave 1', label: 'Free shipping progress bar' },
    { id: 'w06', wave: 'Wave 1', label: 'Localized payment methods' },

    { id: 'w07', wave: 'Wave 2', label: 'Express checkout high in cart' },
    { id: 'w08', wave: 'Wave 2', label: 'Product video as first gallery slide' },
    { id: 'w09', wave: 'Wave 2', label: 'UGC photo strip on PDP' },
    { id: 'w10', wave: 'Wave 2', label: 'Custom native cart drawer' },
    { id: 'w11', wave: 'Wave 2', label: 'Volume discount tiers' },
    { id: 'w12', wave: 'Wave 2', label: 'Gallery first mobile PDP', exclusive: 'pdp-layout' },
    { id: 'w13', wave: 'Wave 2', label: 'Visual collection tiles on homepage' },
    { id: 'w14', wave: 'Wave 2', label: 'Compact homepage hero' },
    { id: 'w15', wave: 'Wave 2', label: 'Regional shipping reassurance, rebuilt' },
    { id: 'w16', wave: 'Wave 2', label: 'Duties and fees clarity' },

    { id: 'w17', wave: 'Wave 3', label: 'Geo specific savings framing' },
    { id: 'w18', wave: 'Wave 3', label: 'Bottom navigation v2' },
    { id: 'w19', wave: 'Wave 3', label: 'Post add to cart upsell' },
    { id: 'w20', wave: 'Wave 3', label: 'Trust row in the cart' },
    { id: 'w21', wave: 'Wave 3', label: 'Bestseller shortcuts in menu' },
    { id: 'w22', wave: 'Wave 3', label: 'Predictive search with images' },
    { id: 'w23', wave: 'Wave 3', label: 'Review stars above the fold' },
    { id: 'w24', wave: 'Wave 3', label: 'Review snippet above the fold' },
    { id: 'w25', wave: 'Wave 3', label: 'Experience framing' },
    { id: 'w26', wave: 'Wave 3', label: 'What is inside strip, revised' },
    { id: 'w27b', wave: 'Wave 3', label: 'Add to cart copy: Start My Build', exclusive: 'atc-copy' },
    { id: 'w27c', wave: 'Wave 3', label: 'Add to cart copy: Get This Kit', exclusive: 'atc-copy' },
    { id: 'w28', wave: 'Wave 3', label: 'Gallery thumbnails instead of dots' },

    { id: 'w29', wave: 'Backlog', label: 'Single benefit line' },
    { id: 'w30', wave: 'Backlog', label: 'Social proof count badge' },
    { id: 'w31', wave: 'Backlog', label: 'Hero with direct category links' },
    { id: 'w32', wave: 'Backlog', label: 'International hero messaging' },
    { id: 'w33', wave: 'Backlog', label: 'Price anchoring, clean price' },
    { id: 'w34', wave: 'Backlog', label: 'Gift framing' },
    { id: 'w35', wave: 'Backlog', label: 'Cart reservation timer' },
    { id: 'w36', wave: 'Backlog', label: 'Quantity selector hidden' },
    { id: 'w37', wave: 'Backlog', label: 'Collection grid density, 2 columns' },
    { id: 'w38', wave: 'Backlog', label: 'Below-fold brand line' }
  ];

  /* ------------------------------------------------------------------------
     Helpers
     ------------------------------------------------------------------------ */
  function on(id) {
    return root.classList.contains('kop-' + id);
  }

  function $(selector, scope) {
    return (scope || document).querySelector(selector);
  }

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  function onFlag(handler) {
    document.addEventListener('kopstorm:flag', function (event) {
      if (event.detail && String(event.detail.id).charAt(0) === 'w') handler(event.detail.id);
    });
  }

  function onCart(handler) {
    ['cart:updated', 'cart:refresh', 'cart:bundled'].forEach(function (name) {
      document.addEventListener(name, handler);
    });
  }

  function formatMoney(cents) {
    var format = (window.theme && window.theme.moneyFormat) || null;
    var amount = (cents / 100).toFixed(2);
    if (!format) return amount;
    return format.replace(/\{\{\s*\w+\s*\}\}/, amount);
  }

  function addToCart(variantId, quantity) {
    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + 'cart/add.js'
      : '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }] })
    }).then(function (response) {
      return response.json();
    }).then(function (payload) {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
      return payload;
    });
  }

  /* ------------------------------------------------------------------------
     W04 and W19 - one click add buttons on the set block and the cart upsell
     ------------------------------------------------------------------------ */
  document.addEventListener('click', function (event) {
    var button = event.target.closest ? event.target.closest('[data-kopw-add-variant]') : null;
    if (!button) return;

    event.preventDefault();
    if (button.disabled) return;

    button.disabled = true;
    addToCart(button.getAttribute('data-kopw-add-variant'), 1)
      .then(function () {
        button.classList.add('is-done');
        var label = button.querySelector('span');
        if (label) label.textContent = button.getAttribute('data-kopw-done') || 'Added';
      })
      .catch(function () {
        button.disabled = false;
      });
  });

  /* ------------------------------------------------------------------------
     W03 - pay later instalment amount, kept in step with the selected variant
     ------------------------------------------------------------------------ */
  function syncInstalments(price) {
    $$('[data-kopw-module="w03"]').forEach(function (node) {
      var base = price != null ? price : parseInt(node.getAttribute('data-kopw-price'), 10);
      var splits = parseInt(node.getAttribute('data-kopw-splits'), 10) || 4;
      var slot = node.querySelector('[data-kopw-instalment]');
      if (!slot || !base) return;
      if (price != null) node.setAttribute('data-kopw-price', String(price));
      slot.textContent = formatMoney(Math.round(base / splits));
    });
  }

  document.addEventListener('variant:change', function (event) {
    var variant = event.detail && (event.detail.variant || (event.detail.data && event.detail.data.variant));
    if (variant && typeof variant.price === 'number') syncInstalments(variant.price);
  });

  /* ------------------------------------------------------------------------
     W24 - rotating review snippet
     ------------------------------------------------------------------------ */
  if (!customElements.get('kopw-quote')) {
    customElements.define('kopw-quote', class extends HTMLElement {
      connectedCallback() {
        var raw = this.querySelector('[data-kopw-quote-data]');
        this.slot_ = this.querySelector('[data-kopw-quote-slot]');
        if (!raw || !this.slot_) return;

        try {
          this.items = JSON.parse(raw.textContent) || [];
        } catch (error) {
          this.items = [];
        }
        if (this.items.length < 2) return;

        this.index = 0;
        var seconds = parseInt(this.dataset.interval, 10) || 7;
        this.timer = setInterval(this.advance.bind(this), seconds * 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      advance() {
        if (document.hidden) return;
        this.index = (this.index + 1) % this.items.length;

        var parts = String(this.items[this.index]).split('::');
        var text = (parts[0] || '').trim();
        var author = parts.length > 1 ? parts[1].trim() : '';

        this.slot_.classList.add('is-fading');
        setTimeout(function () {
          this.slot_.innerHTML = '';

          var textNode = document.createElement('span');
          textNode.className = 'kopw-quote__text';
          textNode.textContent = text;
          this.slot_.appendChild(textNode);

          if (author) {
            var authorNode = document.createElement('span');
            authorNode.className = 'kopw-quote__author';
            authorNode.textContent = author;
            this.slot_.appendChild(authorNode);
          }

          this.slot_.classList.remove('is-fading');
        }.bind(this), 240);
      }
    });
  }

  /* ------------------------------------------------------------------------
     W05 - free shipping progress bar
     ------------------------------------------------------------------------ */
  if (!customElements.get('kopw-ship-bar')) {
    customElements.define('kopw-ship-bar', class extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 0;
        this.total = parseInt(this.dataset.total, 10) || 0;
        this.text = this.querySelector('[data-kopw-shipbar-text]');
        this.track = this.querySelector('[data-kopw-shipbar-track]');
        this.fill = this.querySelector('[data-kopw-shipbar-fill]');
        if (!this.threshold || !this.text) return;

        this.render();
        this.refresh = this.refresh.bind(this);
        onCart(this.refresh);
      }

      refresh() {
        fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js')
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            this.total = cart.total_price;
            this.render();
          }.bind(this))
          .catch(function () { /* leave the last known state on screen */ });
      }

      render() {
        var remaining = Math.max(this.threshold - this.total, 0);
        var percent = Math.min(Math.round((this.total / this.threshold) * 100), 100);
        var unlocked = remaining === 0;

        this.text.classList.toggle('is-unlocked', unlocked);
        if (this.fill) {
          this.fill.style.width = percent + '%';
          this.fill.classList.toggle('is-unlocked', unlocked);
        }
        if (this.track) this.track.setAttribute('aria-valuenow', String(percent));

        var copy = this.getAttribute(unlocked ? 'data-copy-unlocked' : 'data-copy-remaining');
        if (!copy) {
          copy = unlocked
            ? 'Your order ships free.'
            : 'You are <strong>[amount]</strong> away from free shipping.';
        }
        this.text.innerHTML = copy.replace('[amount]', formatMoney(remaining));
      }
    });
  }

  /* ------------------------------------------------------------------------
     W35 - cart reservation timer
     ------------------------------------------------------------------------ */
  if (!customElements.get('kopw-reserve')) {
    customElements.define('kopw-reserve', class extends HTMLElement {
      connectedCallback() {
        this.clock = this.querySelector('[data-kopw-reserve-clock]');
        this.fill = this.querySelector('[data-kopw-reserve-fill]');
        this.span = (parseInt(this.dataset.minutes, 10) || 15) * 60;

        var key = 'kopstorm:w35:deadline';
        var stored = null;
        try { stored = sessionStorage.getItem(key); } catch (error) { /* storage unavailable */ }

        var now = Date.now();
        this.deadline = stored && Number(stored) > now ? Number(stored) : now + this.span * 1000;
        try { sessionStorage.setItem(key, String(this.deadline)); } catch (error) { /* storage unavailable */ }

        this.tick();
        this.timer = setInterval(this.tick.bind(this), 1000);
      }

      disconnectedCallback() {
        if (this.timer) clearInterval(this.timer);
      }

      tick() {
        var left = Math.max(Math.round((this.deadline - Date.now()) / 1000), 0);
        var minutes = Math.floor(left / 60);
        var seconds = left % 60;

        if (this.clock) this.clock.textContent = minutes + ':' + String(seconds).padStart(2, '0');
        if (this.fill) this.fill.style.width = Math.max((left / this.span) * 100, 0) + '%';
        if (left === 0 && this.timer) clearInterval(this.timer);
      }
    });
  }

  /* ------------------------------------------------------------------------
     W11 - volume discount tiers, wired to the product form quantity
     ------------------------------------------------------------------------ */
  if (!customElements.get('kopw-volume')) {
    customElements.define('kopw-volume', class extends HTMLElement {
      connectedCallback() {
        this.tiers = $$('[data-kopw-qty]', this);
        this.addEventListener('click', this.pick.bind(this));
      }

      pick(event) {
        var tier = event.target.closest('[data-kopw-qty]');
        if (!tier) return;

        this.tiers.forEach(function (node) {
          var active = node === tier;
          node.classList.toggle('is-selected', active);
          node.setAttribute('aria-checked', active ? 'true' : 'false');
        });

        var form = document.getElementById(this.dataset.formId);
        var input = form ? form.querySelector('input[name="quantity"]') : null;
        if (!input) input = $('.product__info input[name="quantity"]');
        if (!input) return;

        input.value = tier.getAttribute('data-kopw-qty');
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  }

  /* ------------------------------------------------------------------------
     W34 - gift wrap line item property
     ------------------------------------------------------------------------ */
  if (!customElements.get('kopw-gift-frame')) {
    customElements.define('kopw-gift-frame', class extends HTMLElement {
      connectedCallback() {
        var box = this.querySelector('[data-kopw-giftwrap]');
        if (!box) return;
        box.addEventListener('change', this.sync.bind(this, box));
      }

      sync(box) {
        var form = document.getElementById(this.dataset.formId);
        if (!form) return;

        var field = form.querySelector('input[name="properties[Gift wrapping]"]');
        if (box.checked) {
          if (!field) {
            field = document.createElement('input');
            field.type = 'hidden';
            field.name = 'properties[Gift wrapping]';
            form.appendChild(field);
          }
          field.value = 'Yes';
        } else if (field) {
          field.remove();
        }
      }
    });
  }

  /* ------------------------------------------------------------------------
     W02 - upgraded gallery lightbox with swipe, zoom and thumbnails
     ------------------------------------------------------------------------ */
  var lightbox = {
    node: null,
    slides: [],
    index: 0,

    sources: function () {
      var gallery = $('.product__gallery');
      if (!gallery) return [];

      return $$('.product__media img', gallery).map(function (image) {
        var srcset = image.getAttribute('srcset') || '';
        var best = srcset
          .split(',')
          .map(function (part) { return part.trim().split(' ')[0]; })
          .filter(Boolean)
          .pop();
        return {
          full: best || image.currentSrc || image.src,
          thumb: image.currentSrc || image.src,
          alt: image.getAttribute('alt') || ''
        };
      }).filter(function (item) { return !!item.full; });
    },

    build: function () {
      if (this.node) return this.node;

      var wrap = document.createElement('div');
      wrap.className = 'kopw-lightbox';
      wrap.setAttribute('role', 'dialog');
      wrap.setAttribute('aria-modal', 'true');
      wrap.innerHTML =
        '<div class="kopw-lightbox__bar">' +
          '<span class="kopw-lightbox__counter" data-counter></span>' +
          '<span class="kopw-lightbox__tools">' +
            '<button type="button" class="kopw-lightbox__btn" data-zoom aria-pressed="false" aria-label="Zoom">' +
              '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><circle cx="9" cy="9" r="5.6" fill="none" stroke="currentColor" stroke-width="1.4"/><path d="M13.2 13.2L17 17M6.6 9h4.8M9 6.6v4.8" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
            '</button>' +
            '<button type="button" class="kopw-lightbox__btn" data-close aria-label="Close">' +
              '<svg viewBox="0 0 20 20" width="16" height="16" aria-hidden="true"><path d="M5.4 5.4l9.2 9.2M14.6 5.4l-9.2 9.2" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round"/></svg>' +
            '</button>' +
          '</span>' +
        '</div>' +
        '<button type="button" class="kopw-lightbox__nav kopw-lightbox__nav--prev" data-prev aria-label="Previous">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M10 3.2L5.6 8 10 12.8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<button type="button" class="kopw-lightbox__nav kopw-lightbox__nav--next" data-next aria-label="Next">' +
          '<svg viewBox="0 0 16 16" width="14" height="14" aria-hidden="true"><path d="M6 3.2L10.4 8 6 12.8" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/></svg>' +
        '</button>' +
        '<div class="kopw-lightbox__stage" data-stage></div>' +
        '<div class="kopw-lightbox__thumbs" data-thumbs></div>';

      document.body.appendChild(wrap);
      this.node = wrap;

      wrap.querySelector('[data-close]').addEventListener('click', this.close.bind(this));
      wrap.querySelector('[data-prev]').addEventListener('click', this.step.bind(this, -1));
      wrap.querySelector('[data-next]').addEventListener('click', this.step.bind(this, 1));
      wrap.querySelector('[data-zoom]').addEventListener('click', this.toggleZoom.bind(this));

      wrap.querySelector('[data-stage]').addEventListener('scroll', this.onScroll.bind(this), { passive: true });

      document.addEventListener('keydown', function (event) {
        if (!wrap.classList.contains('is-open')) return;
        if (event.key === 'Escape') this.close();
        if (event.key === 'ArrowLeft') this.step(-1);
        if (event.key === 'ArrowRight') this.step(1);
      }.bind(this));

      return wrap;
    },

    open: function (startIndex) {
      var items = this.sources();
      if (!items.length) return;

      var wrap = this.build();
      var stage = wrap.querySelector('[data-stage]');
      var thumbs = wrap.querySelector('[data-thumbs]');

      stage.innerHTML = '';
      thumbs.innerHTML = '';

      items.forEach(function (item, i) {
        var slide = document.createElement('div');
        slide.className = 'kopw-lightbox__slide';

        var image = document.createElement('img');
        image.className = 'kopw-lightbox__img';
        image.src = item.full;
        image.alt = item.alt;
        image.loading = i === startIndex ? 'eager' : 'lazy';
        image.addEventListener('click', this.toggleZoom.bind(this));

        slide.appendChild(image);
        stage.appendChild(slide);

        var thumb = document.createElement('button');
        thumb.type = 'button';
        thumb.className = 'kopw-lightbox__thumb';
        thumb.innerHTML = '<img src="' + item.thumb + '" alt="" loading="lazy">';
        thumb.addEventListener('click', this.goTo.bind(this, i));
        thumbs.appendChild(thumb);
      }.bind(this));

      this.slides = $$('.kopw-lightbox__slide', wrap);
      this.total = items.length;

      wrap.classList.add('is-open');
      root.classList.add('kopw-lightbox-open');

      this.goTo(startIndex || 0, true);
    },

    goTo: function (index, instant) {
      if (!this.node) return;
      var stage = this.node.querySelector('[data-stage]');
      this.index = Math.max(0, Math.min(index, this.total - 1));
      stage.scrollTo({ left: stage.clientWidth * this.index, behavior: instant ? 'auto' : 'smooth' });
      this.paint();
    },

    step: function (delta) {
      this.goTo(this.index + delta);
    },

    onScroll: function () {
      if (!this.node) return;
      var stage = this.node.querySelector('[data-stage]');
      var next = Math.round(stage.scrollLeft / stage.clientWidth);
      if (next !== this.index) {
        this.index = next;
        this.paint();
      }
    },

    paint: function () {
      if (!this.node) return;
      var counter = this.node.querySelector('[data-counter]');
      if (counter) counter.textContent = (this.index + 1) + ' / ' + this.total;

      $$('.kopw-lightbox__thumb', this.node).forEach(function (thumb, i) {
        thumb.classList.toggle('is-active', i === this.index);
      }.bind(this));

      this.slides.forEach(function (slide) { slide.classList.remove('is-zoomed'); });
      var zoomButton = this.node.querySelector('[data-zoom]');
      if (zoomButton) zoomButton.setAttribute('aria-pressed', 'false');
    },

    toggleZoom: function () {
      var slide = this.slides[this.index];
      if (!slide) return;
      var zoomed = slide.classList.toggle('is-zoomed');
      var zoomButton = this.node.querySelector('[data-zoom]');
      if (zoomButton) zoomButton.setAttribute('aria-pressed', zoomed ? 'true' : 'false');
    },

    close: function () {
      if (!this.node) return;
      this.node.classList.remove('is-open');
      root.classList.remove('kopw-lightbox-open');
    }
  };

  document.addEventListener('click', function (event) {
    if (!on('w02')) return;
    if (!event.target.closest) return;

    var media = event.target.closest('.product__gallery .product__media');
    if (!media) return;

    var gallery = media.closest('.product__gallery');
    var all = $$('.product__media', gallery);

    event.preventDefault();
    event.stopPropagation();
    lightbox.open(all.indexOf(media));
  }, true);

  /* ------------------------------------------------------------------------
     W08 - product video as the first gallery slide
     ------------------------------------------------------------------------ */
  function videoFirst() {
    if (!on('w08')) return;

    var list = $('.product__media-list');
    if (!list || list.dataset.kopwVideoFirst === 'true') return;

    var slides = $$(':scope > *', list);
    var video = slides.filter(function (slide) {
      return slide.querySelector('video, [data-media-type="video"], deferred-media, product-model');
    })[0];

    if (!video || slides.indexOf(video) === 0) return;

    list.insertBefore(video, list.firstElementChild);
    list.dataset.kopwVideoFirst = 'true';

    var player = video.querySelector('video');
    if (player) {
      player.muted = true;
      player.setAttribute('playsinline', '');
      var attempt = player.play();
      if (attempt && attempt.catch) attempt.catch(function () { /* autoplay refused */ });
    }
  }

  /* ------------------------------------------------------------------------
     W10 - native cart drawer, third party drawer stood down
     ------------------------------------------------------------------------ */
  function nativeDrawer() {
    if (!on('w10')) return;
    if (root.dataset.kopwNativeDrawer === 'true') return;
    root.dataset.kopwNativeDrawer = 'true';

    /* Stop the app drawer from opening, then hand the click to the theme drawer. */
    document.addEventListener('click', function (event) {
      if (!on('w10')) return;
      var trigger = event.target.closest && event.target.closest('[href$="/cart"], [aria-controls="CartDrawer"], .header__cart, [data-cart-toggle]');
      if (!trigger) return;

      var drawer = document.getElementById('CartDrawer');
      if (!drawer) return;

      event.preventDefault();
      event.stopImmediatePropagation();

      if (typeof drawer.show === 'function') drawer.show();
      else drawer.setAttribute('open', '');
    }, true);
  }

  /* ------------------------------------------------------------------------
     W12 - gallery first mobile PDP, price and CTA overlaid on the gallery
     ------------------------------------------------------------------------ */
  function galleryFirst() {
    var container = $('.product__gallery-container');
    if (!container) return;

    var wanted = on('w12');
    var existing = $('.kopw-overlay', container);

    if (!wanted) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var title = $('.product__info h1');
    var price = $('.product__info .kop-price__current') || $('.product__info .price__regular') || $('.product__info .price');
    var submit = $('.product__info .product-form__submit') || $('.product__info button[name="add"]');

    var overlay = document.createElement('div');
    overlay.className = 'kopw-overlay';
    overlay.innerHTML =
      '<p class="kopw-overlay__title"></p>' +
      '<p class="kopw-overlay__price"></p>' +
      '<button type="button" class="kopw-overlay__cta"></button>';

    overlay.querySelector('.kopw-overlay__title').textContent = title ? title.textContent.trim() : '';
    overlay.querySelector('.kopw-overlay__price').textContent = price ? price.textContent.trim() : '';

    var cta = overlay.querySelector('.kopw-overlay__cta');
    cta.textContent = submit ? submit.textContent.trim() : 'Add to cart';
    cta.addEventListener('click', function () {
      if (submit) submit.click();
    });

    container.appendChild(overlay);
  }

  /* ------------------------------------------------------------------------
     W17 - geo specific savings framing needs to know the market
     ------------------------------------------------------------------------ */
  function markMarket() {
    var country = (window.Shopify && window.Shopify.country) || '';
    root.classList.toggle('kopw-market-us', String(country).toUpperCase() === 'US');
  }

  /* ------------------------------------------------------------------------
     W21 - bestseller shortcuts pinned to the top of the mobile menu
     ------------------------------------------------------------------------ */
  function menuShortcuts() {
    var wanted = on('w21');
    var menu = $('.menu-drawer__navigation, .drawer__menu, [data-menu-drawer] ul, .header__drawer nav ul');
    var existing = $('[data-kopw-shortcuts]');

    if (!wanted || !menu) {
      if (existing) existing.remove();
      return;
    }
    if (existing) return;

    var config = (window.KopstormW2 && window.KopstormW2.shortcuts) || [];
    if (!config.length) return;

    var strip = document.createElement('div');
    strip.className = 'kopw kopw-catlinks';
    strip.setAttribute('data-kopw-shortcuts', '');
    strip.style.display = 'flex';
    strip.style.padding = '10px 0';

    config.forEach(function (item) {
      var link = document.createElement('a');
      link.className = 'kopw-catlinks__link';
      link.href = item.url;
      link.innerHTML = '<span></span>';
      link.querySelector('span').textContent = item.label;
      strip.appendChild(link);
    });

    menu.parentNode.insertBefore(strip, menu);
  }

  /* ------------------------------------------------------------------------
     W22 - predictive search results with thumbnails and prices
     The theme already renders images in its results markup, so this only
     unhides them and pulls the price line up next to the title.
     ------------------------------------------------------------------------ */
  function richSearch() {
    var wanted = on('w22');
    document.querySelectorAll('.search__results, predictive-search').forEach(function (node) {
      node.classList.toggle('kopw-rich-search', wanted);
    });
  }

  /* ------------------------------------------------------------------------
     W27 - add to cart button copy
     ------------------------------------------------------------------------ */
  var atcOriginal = null;

  function buttonCopy() {
    var buttons = $$('.product-form__submit, .product__info button[name="add"]');
    if (!buttons.length) return;

    if (atcOriginal === null) {
      var first = buttons[0].querySelector('.btn-text span, .btn-text') || buttons[0];
      atcOriginal = first.textContent.trim();
    }

    var copy = atcOriginal;
    if (on('w27b')) copy = (window.KopstormW2 && window.KopstormW2.atcB) || 'Start my build';
    else if (on('w27c')) copy = (window.KopstormW2 && window.KopstormW2.atcC) || 'Get this kit';

    buttons.forEach(function (button) {
      var slot = button.querySelector('.btn-text span') || button.querySelector('.btn-text') || button;
      if (slot.textContent.trim() !== copy) slot.textContent = copy;
    });
  }

  /* ------------------------------------------------------------------------
     W07 - express checkout high in cart
     The wallet buttons are rendered straight into the drawer slot by
     kopstorm-w2-cart.liquid, so there is nothing to do here. On the cart page
     the slot stays empty on purpose: content_for_additional_checkout_buttons
     may only be output once per page and main-cart already owns it there.
     ------------------------------------------------------------------------ */

  /* ------------------------------------------------------------------------
     Preview toolbar
     ------------------------------------------------------------------------ */
  function toolbar() {
    var host = $('[data-kopw-toolbar]');
    if (!host || host.dataset.built === 'true') return;
    host.dataset.built = 'true';

    var handle = $('[data-kopw-toolbar-handle]', host);
    var panel = $('[data-kopw-toolbar-panel]', host);
    var groups = $('[data-kopw-toolbar-groups]', host);
    var count = $('[data-kopw-toolbar-count]', host);

    handle.addEventListener('click', function () {
      var open = panel.hidden;
      panel.hidden = !open;
      handle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });

    var waves = [];
    TESTS.forEach(function (test) {
      if (waves.indexOf(test.wave) === -1) waves.push(test.wave);
    });

    waves.forEach(function (wave) {
      var title = document.createElement('p');
      title.className = 'kopw-toolbar__group-title';
      title.textContent = wave;
      groups.appendChild(title);

      TESTS.filter(function (test) { return test.wave === wave; }).forEach(function (test) {
        var row = document.createElement('label');
        row.className = 'kopw-toolbar__row' + (test.exclusive ? ' kopw-toolbar__row--exclusive' : '');

        var box = document.createElement('input');
        box.type = 'checkbox';
        box.checked = on(test.id);
        box.addEventListener('change', function () {
          if (box.checked && test.exclusive) {
            TESTS.forEach(function (other) {
              if (other !== test && other.exclusive === test.exclusive) {
                window.KopstormCRO.disable(other.id);
              }
            });
          }
          window.KopstormCRO[box.checked ? 'enable' : 'disable'](test.id);
          sync();
        });

        var id = document.createElement('span');
        id.className = 'kopw-toolbar__id';
        id.textContent = test.id.toUpperCase();

        var label = document.createElement('span');
        label.textContent = test.label;

        row.appendChild(box);
        row.appendChild(id);
        row.appendChild(label);
        groups.appendChild(row);
      });
    });

    function sync() {
      var active = 0;
      $$('.kopw-toolbar__row', groups).forEach(function (row, i) {
        var test = TESTS[i];
        var box = row.querySelector('input');
        box.checked = on(test.id);
        if (box.checked) active += 1;
      });
      count.textContent = String(active);
    }

    $('[data-kopw-toolbar-all]', host).addEventListener('click', function () {
      TESTS.forEach(function (test) {
        if (test.exclusive) return;
        window.KopstormCRO.enable(test.id);
      });
      sync();
    });

    $('[data-kopw-toolbar-none]', host).addEventListener('click', function () {
      TESTS.forEach(function (test) { window.KopstormCRO.disable(test.id); });
      root.classList.remove('kop-w2preview');
      sync();
    });

    sync();
  }

  /* ------------------------------------------------------------------------
     Boot and re-run on flag changes
     ------------------------------------------------------------------------ */
  function apply() {
    markMarket();
    syncInstalments();
    videoFirst();
    nativeDrawer();
    galleryFirst();
    menuShortcuts();
    richSearch();
    buttonCopy();
  }

  function boot() {
    apply();
    toolbar();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  onFlag(apply);
  document.addEventListener('shopify:section:load', apply);

  /* Public surface, mostly for QA in the console. */
  window.KopstormW2 = Object.assign(window.KopstormW2 || {}, {
    tests: TESTS,
    lightbox: lightbox,
    refresh: apply
  });
})();
